/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Pos_RightInputs */

const vi_shop_home_pos_right = /** @type {(inputs: Shop_Home_Pos_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phải`)
};

/**

* @param {Shop_Home_Pos_RightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_pos_right = /** @type {((inputs?: Shop_Home_Pos_RightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Pos_RightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_pos_right(inputs)
});